import {RootStoreState} from '../../stores/RootStoreState';
import {IProductOptionSelection} from '@wix/wixstores-graphql-schema/dist/src';

export const getOptionSelections = (state: RootStoreState): IProductOptionSelection[] =>
  state.product.options.reduce((acc, option) => {
    const selected =
      (option.selections.find((s) => s.id === state.selectionInput[option.id]) as IProductOptionSelection) || null;
    return [...acc, selected];
  }, []);
